import { render, staticRenderFns } from "./ChartThree.vue?vue&type=template&id=23ec1867&scoped=true"
import script from "./ChartThree.vue?vue&type=script&lang=js"
export * from "./ChartThree.vue?vue&type=script&lang=js"
import style0 from "./ChartThree.vue?vue&type=style&index=0&id=23ec1867&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ec1867",
  null
  
)

export default component.exports